














































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { LoadingService } from '@/services/loadingService';
import ValidaRut from '@/config/validaRut';
import { Validator } from 'vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import { fetchClientesCanal } from '@/pantallas/ClientesCanal/fetchClientesCanal';
import { MarcaBlanca } from '@/config/marcaBlanca.ts';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
  },
})
export default class CrearClienteModal extends Vue {
  @Prop({ default: true }) show: boolean;
  title: string = 'Crear Cliente';
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  vr: ValidaRut = new ValidaRut();
  showInfo: boolean = true;
  isFormValid: boolean = true;
  marcaBlanca: MarcaBlanca = new MarcaBlanca();
  formFields: {
    rut: { label: string; value: string };
    nombre: { label: string; value: string };
    giro: { label: string; value: string };
    direccion: { label: string; value: string };
    calle: { label: string; value: string };
    numero: { label: string; value: string };
    comuna: { label: string; value: string };
    provincia: { label: string; value: string };
    region: { label: string; value: string };
    telefono_1: { label: string; value: string };
    telefono_2: { label: string; value: string };
    canal: {label: string; value: string};
  } = {
    rut: { label: 'Rut', value: '' },
    nombre: { label: 'Nombre', value: '' },
    giro: { label: 'Giro', value: '' },
    direccion: { label: 'Dirección', value: '' },
    calle: { label: 'Calle', value: '' },
    numero: { label: 'Número', value: '' },
    comuna: { label: 'Comuna', value: '' },
    provincia: { label: 'Provincia', value: '' },
    region: { label: 'Región', value: '' },
    telefono_1: { label: 'Teléfono 1', value: '' },
    telefono_2: { label: 'Teléfono 2', value: '' },
    canal: {label: 'Canal', value: ''}
  };

  /* misc */

  @Watch('show', { immediate: true })
  onShowChange() {
    if (this.show) {
      console.log('ClearFields!');
      this.clearFields();
    }
  }

  readonly $snotify: any;
  readonly loadingService = new LoadingService();

  created() {
    var r = this.vr;

    Validator.extend('rut', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.Rut(value),
            data: r.Rut(value)
              ? undefined
              : {
                  message: '* Rut inválido',
                },
          });
        });
      },
    });
    Validator.extend('rutFormato', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Formato de Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.validaFormatoRut(value),
            data: r.validaFormatoRut(value)
              ? undefined
              : { message: '* Formato de Rut inválido' },
          });
        });
      },
    });
  }

  clearFields() {
    this.formFields = {
      rut: { label: 'Rut', value: '' },
      nombre: { label: 'Nombre', value: '' },
      giro: { label: 'Giro', value: '' },
      direccion: { label: 'Dirección', value: '' },
      calle: { label: 'Calle', value: '' },
      numero: { label: 'Número', value: '' },
      comuna: { label: 'Comuna', value: '' },
      provincia: { label: 'Provincia', value: '' },
      region: { label: 'Región', value: '' },
      telefono_1: { label: 'Teléfono 1', value: '' },
      telefono_2: { label: 'Teléfono 2', value: '' },
      canal: {label: 'Canal', value: ''}
    };
  }

  async handleSaveClient() {
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      const body = {
        rut: this.formFields.rut.value,
        nombre: this.formFields.nombre.value,
        giro: this.formFields.giro.value,
        direccion: this.formFields.direccion.value,
        calle: this.formFields.calle.value,
        numero: this.formFields.numero.value,
        comuna: this.formFields.comuna.value,
        provincia: this.formFields.provincia.value,
        region: this.formFields.region.value,
        telefono_1: this.formFields.telefono_1.value,
        telefono_2: this.formFields.telefono_2.value,
        userid: this.getUserID().toString(),
        canal: this.formFields.canal.value != '' ? this.formFields.canal.value : this.marcaBlanca.getSubDomain(),
      };
      this.postClient(body);
    }
  }

  async postClient(body: any) {
    this.loadingService.showLoading();
    fetchClientesCanal(body, 'PostChannelsClient')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success('El cliente se ha creado con éxito');
          this.handleCerrar();
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al crear el cliente');
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  handleInfoGeneral() {}

  handleCerrar() {
    this.$emit('cerrar');
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  get valideSubDomain(): boolean {
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = this.marcaBlanca.SubDomain();
    // Si se encontró un subdominio, lo retornamos
    if (subdominio != '') {
      switch (subdominio) 
      {
        case 'gpstrack':
          return true;
        case 'track3':
          return true;
        case 'qagpstrack':
          return true;
          case 'localhost':
          return true;
        default:
          return false;
      }
    } else {
      return true; // No se encontró un subdominio
    }
  }
}
